import script from "./keyboard.vue?vue&type=script&setup=true&lang=js"
export * from "./keyboard.vue?vue&type=script&setup=true&lang=js"

import "./keyboard.vue?vue&type=style&index=0&id=bde789ec&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bde789ec"]])

export default __exports__